import { useImageUrl } from '@/hooks/useImageUrl';
import { getAvatarColor } from '@/utils/avatarColors';
import { Avatar as AntAvatar } from 'antd';

interface AvatarProps {
  src?: string;
  size?: 'small' | 'default' | 'large' | number;
  className?: string;
  userName?: string;
  text?: string;
  [key: string]: any;
}

export default function Avatar({ src, size, className, userName, text, ...rest }: AvatarProps) {
  const backgroundColor = getAvatarColor(userName || '');

  const { imgUrl, loading } = useImageUrl({
    filePath: src || null,
    autoLoad: !!src,
  });

  return (
    <AntAvatar
      src={imgUrl}
      size={size}
      className={className}
      {...rest}
      style={{
        backgroundColor: !imgUrl ? backgroundColor : undefined, // Chỉ hiển thị background khi không có ảnh
        color: '#fff',
        ...rest.style,
      }}
    >
      {!imgUrl && (userName?.charAt(0).toUpperCase() || text)}{' '}
      {/* Chỉ hiển thị text khi không có ảnh */}
    </AntAvatar>
  );
}
